/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

export default function Pagination({ total, perPage, url, page = 1 }) {
  const [pages, setPages] = useState([])

  useEffect(() => {
    const x = (total - 1) / perPage
    const output = []
    for (let i = 1; i <= x + 1; i++) {
      output.push(i)
    }
    setPages([...output])
  }, [total])

  return (
    <nav aria-label="Page navigation example">
      <ul className="pagination">
        {pages.map((p, i, arr) => {
          const cp = parseInt(page)
          const delta = 5
          if ((p > cp - delta && cp + delta > p) || p === 1 || p === (arr.length)) {
            return <li className={`page-item ${cp === p ? 'active' : ''}`} key={p}>
              <a className={`page-link`} href={`${url}/${p}`}>{p}</a>
            </li>
          } else {
            return null
          }
        })}
      </ul>
    </nav >
  );
}
